<template>
  <div class="prepare-question__choice">
    <div class="prepare-question__choice__head display-flex justify-content-between">
        <div class="answer__left secondary-color-txt font-sanpro-semibold">Đáp án</div>
        <div class="answer__correct secondary-color-txt font-sanpro-semibold">Đúng</div>
        <div class="answer__del"></div>
    </div>
    <div class="answer__body" :class="{'form-item-err': isSubmit && notCorrect && questionDetail.answers.length > 0}">
      <div v-for="(item, index) of questionDetail.answers" :key="index" class="answer display-flex justify-content-between">
        <div class="answer__left display-flex">
          <div class="form-item form-item__code">
            <label class="text-center">Mã câu trả lời <span class="color-err">*</span></label>
            <input
              type="text"
              name="code"
              class="form-h35 border-rd-20 full-width text-center"
              placeholder="A/B"
              v-model="item.code"
              autocomplete="off"
              :class="{'form-item-err': isSubmit && !item.code}"
            >
            <div v-if="isSubmit && !item.code" class="form-item__noti color-err font-size-15 mt-2">Bạn hãy nhập Mã</div>
          </div>
          <div class="form-item form-item__content">
            <label>Nội dung <span class="color-err">*</span></label>
            <div
              class="form-item__editor"
              :class="{ 'form-item-err': isSubmit && (!item.content || (item.content && item.content === contentDefault)) && !item.imageUrl}"
            >
              <EdittorCKAnswer 
                :contentEditor="item.content"
                :position="index + '_' + indexQuestionWorking"
              />
            </div>
            <div v-if="isSubmit && (!item.content || (item.content && item.content === contentDefault)) && !item.imageUrl " class="form-item__noti color-err font-size-15 mt-2">
              Bạn hãy nhập vào nội dung 
            </div>
          </div>
          <div class="form-item form-item__img mg-item__img">
            <div v-if="item && item.imageUrl" class="img-layout form-file-hide">
              <input type="file" class="ipt-upload" @change="changeImgAnswerItem($event, index)" accept="image/*">
              <template class="display-flex">
                <img 
                  :src="questionDetail.isSample ? `${cdnUrl}/${item.imageUrl}` : `${appUrl}/${item.imageUrl}`"
                  class="img-answer"
                  alt="Ảnh câu trả lời" 
                />
                <b-button
                  type="button"
                  class="btn btn-danger del-img"
                  v-b-tooltip.hover
                  title="Xóa ảnh"
                  variant="outline-danger"
                  @click="delImgOfAnswer($event, index)"
                >
                  <i class="icon-lesson-trash color-light font-size-16"></i>
                </b-button>
              </template>
            </div>
            <a
              v-else
              href="javascript:;"
              class="font-size-16 font-sanpro-semibold display-flex full-box flex-direction-col position-rel"
              v-b-tooltip.hover
              title="Tải ảnh"
            >
              <input type="file" class="ipt-upload" @change="changeImgAnswerItem($event, index)" accept="image/*">
              <!-- <i class="icon-upload secondary-color-txt"></i> -->
              <i class="icon-lesson--picture"></i>
              <!-- <span class="secondary-color-txt">Tải ảnh</span> -->
            </a>
          </div>
          <!-- <div class="form-item form-item__remove mg-item__img">
            <div class="item-del border-rd-50 display-flex-center justify-content-center" v-b-tooltip.hover title="Xóa câu trả lời" @click="removeAnswer(index)">
              <i class="icon-close color-light font-size-7"></i>
            </div>
          </div> -->
        </div>
        <div class="answer__correct">
          <b-form-radio v-model="item.answerContent" @change="changeAnswerCorrect($event, item, index)" name="radios_correct" :value="item.orderNo" />
        </div>
        <div class="form-item form-item__remove mg-item__img">
          <div class="item-del border-rd-50 display-flex-center justify-content-center" v-b-tooltip.hover title="Xóa câu trả lời" @click="removeAnswer(index)">
            <i class="icon-close color-light font-size-7"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isSubmit && (!questionDetail.answers || questionDetail.answers.length === 0)" class="form-item__noti color-err font-size-15 mt-2 text-center mb-2">Bạn hãy thêm ít nhất 1 câu trả lời</div>
    <div v-if="isSubmit && notCorrect && questionDetail.answers.length > 0" class="form-item__noti color-err font-size-15 mt-2 text-center mb-2">Bạn hãy chọn câu trả lời đúng</div>
    <div class="answer__footer">
      <a
        href="javascript:;"
        class="btn btn-gray font-size-16 display-flex-center justify-content-center border-rd-20"
        @click="addNewAnswer()"
      >
        <i class="icon-plus"></i> Thêm đáp án
      </a>
    </div>
    <div class="answer__layout">
      <h3 class="answer__layout__title display-block secondary-color-txt font-sanpro-semibold font-size-17">Giao diện hiển thị:</h3>
      <div class="answer__layout__list">
        <div
          v-for="(item, index) of stylesQuestion"
          :key="index"
          class="item"
          :class="{'active': questionDetail.layoutId === index + 1}"
          @click="setStyleQuestion(index + 1)"
        >
          <img :src="item" alt="Hiển thị câu hỏi">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY, CONTENT_EDITOR_DEFAULT } from './../../_store/constants'
import EdittorCKAnswer from '@/modules/question/EdittorCKAnswer.vue'
import mixinsQuestions from './../../_store/mixinsQuestions'
import QuestionHead from './QuestionHead.vue'
import { APP_CONFIG } from '@/utils/constants'

const imgStyle1 = require('@/assets/images/style-question/radio-1.jpg')
const imgStyle2 = require('@/assets/images/style-question/radio-2.jpg')

export default {
  name: 'QuestionChoice',
  mixins: [ mixinsQuestions ],
  props: {
    isSubmit: Boolean,
    notCorrect: Boolean
  },
  components: {
    EdittorCKAnswer,
    QuestionHead
  },
  data () {
    return {
      imgQuestion: '',
      uploadUrl: APP_CONFIG.uploadUrl,
      cdnUrl: APP_CONFIG.cdnUrl,
      available: false,
      appUrl: APP_CONFIG.appUrl,
      stylesQuestion: [imgStyle1, imgStyle2],
      contentDefault: CONTENT_EDITOR_DEFAULT
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['questionDetail', 'indexQuestionWorking'])
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.mg-item__img{
  margin-top: 32px;
}
</style>